import * as GeneralLineRelationTask from "./FindParameterGeneralLineRelationTask";

export function generateTask() {
  return {
    ...GeneralLineRelationTask.generateTask({ relation: "perpendicular" }),
    type: "FindParameterGeneralPerpendicularTask",
  };
}

export const renderTask = GeneralLineRelationTask.renderTask;
export const renderInput = GeneralLineRelationTask.renderInput;
export const checkAnswer = GeneralLineRelationTask.checkAnswer;
export const renderAnswer = GeneralLineRelationTask.renderAnswer;
export const renderExplanation = GeneralLineRelationTask.renderExplanation;
export const renderUserAnswer = GeneralLineRelationTask.renderUserAnswer;
